document.addEventListener('DOMContentLoaded', () => {
    function updateAllGrids() {
        const containers = document.querySelectorAll('.responsive-grid');

        containers.forEach(container => {
            const items = Array.from(container.children);

            items.forEach(el => el.classList.remove('full'));

            if (items.length < 2) return;

            const last = items[items.length - 1];
            const prev = items[items.length - 2];

            if (last.offsetTop > prev.offsetTop) {
            last.classList.add('full');
            }
        });
    }

window.addEventListener('resize', updateAllGrids);
window.addEventListener('load', updateAllGrids);

});